import Offcanvas from "bootstrap/js/dist/offcanvas";

export default function initOffcanvasSwipe() {
    const draggables = document.querySelectorAll('.offcanvas-draggable');
    
    draggables.forEach(offcanvasEl => {
        let touchStart = { x: 0, y: 0 };
        let touchEnd = { x: 0, y: 0 };
        const threshold = 50; // minimum distance for swipe

        offcanvasEl.addEventListener('touchstart', e => {
            touchStart.x = e.changedTouches[0].screenX;
            touchStart.y = e.changedTouches[0].screenY;
        }, { passive: true });

        offcanvasEl.addEventListener('touchend', e => {
            touchEnd.x = e.changedTouches[0].screenX;
            touchEnd.y = e.changedTouches[0].screenY;
            handleSwipe(offcanvasEl);
        }, { passive: true });

        function handleSwipe(el) {
            const deltaX = touchEnd.x - touchStart.x;
            const deltaY = touchEnd.y - touchStart.y;
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);

            const isHorizontal = absX > absY;
            const offcanvas = Offcanvas.getOrCreateInstance(el);

            if (isHorizontal && absX > threshold) {
                // Determine direction based on offcanvas type
                if (el.classList.contains('offcanvas-end') && deltaX > 0) {
                    // Swipe right to close offcanvas-end
                    offcanvas.hide();
                } else if (el.classList.contains('offcanvas-start') && deltaX < 0) {
                    // Swipe left to close offcanvas-start
                    offcanvas.hide();
                }
            } else if (!isHorizontal && absY > threshold) {
                if (el.classList.contains('offcanvas-bottom') && deltaY > 0) {
                    // Swipe down to close offcanvas-bottom
                    offcanvas.hide();
                } else if (el.classList.contains('offcanvas-top') && deltaY < 0) {
                    // Swipe up to close offcanvas-top
                    offcanvas.hide();
                }
            }
        }
    });
}
